import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { WebRouletteService } from 'app/public/services/web-roulette.service';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { FieldTypes } from 'app/shared/model/enums';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, switchMapTo, tap } from 'rxjs/operators';
import { CommonService } from 'app/shared/services/common.service';
import { Filter } from 'app/shared/components/table/filter';
import { CouponStatus } from 'app/core/model/enums/status-enum';
import { ConfirmationService } from 'primeng/api';
import { CouponService } from 'app/core/services/coupon.service';
import { AdvMessageService } from 'app/shared/services/message.service';
import { BaseLids } from '../base-lids';

@Component({
  selector: 'app-lids',
  templateUrl: './lids.component.html',
  styleUrls: ['./lids.component.scss']
})
export class LidsComponent extends BaseLids implements OnInit, OnDestroy {

  constructor(webRouletteService: WebRouletteService, localizationService: LocalizationService, commonService: CommonService) {
    super(webRouletteService, localizationService, commonService)
  }
  ngOnDestroy(): void {
    this.destroy();
  }
  ngOnInit(): void {
    this.init();
  }
  onLoadData(event) {
    this.request.Paging = event.Paging;
    this.loadLids();
  }

}
